import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import RightSidebar from './../../components/templates/rightsidebar.vue'; 
import LeftSidebar from './../../components/templates/leftsidebar.vue'; 

let service = new services();
export default {
    name: 'Home',
    data () {
        return {
            header_data:{},
            user:{},
            myshops:{},
            loggedIn: false,
            loading: true,
            tab_view: {},
            menu_tab_view:{},
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'right-sidebar': RightSidebar,
        'left-sidebar': LeftSidebar,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        },

    },
    methods: {
        setComponent(attr1,attr2){
            if(attr1 == "reset-edit"){}
        },

        setTabComponent(view){
            this.tab_view = {};
            this.tab_view[view] =  true;
        },

        setMenuTabView(view,attr1,attr2){
            if(this.menu_tab_view[view] == true){//toggle reverse
                this.menu_tab_view = {};
                this.setComponent('reset-edit','');
            }else{
                this.setComponent('reset-edit','');
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }
        },

        preset(){
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.getMyShops();
                    self.loading = false;
                }else {
                    self.$router.push('login');
                    // console.log(err)
                }
            });
        },
        
        getMyShops(){
            var payload = {
                folder_for:1,
                folder_for_id: this.user.user_id,
                folder_type: 9, //myshopa
            }
            service.getSetFolders(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.myshops = response.body.data[0].folder_items; 
                    this.loading = false;
                }
            }).catch((err) => {})
        },

        
    },
    created: function(){
        this.preset();
        this.header_data.name = "My Shops";
    }
}


// WEBPACK FOOTER //
// ./src/pages/MyShops/script.js